import { useCallback, useEffect, useRef, useState } from 'react';
import DIALOGUE_ARROW_ICON from '../../assets/images/dialogue_arrow.png';

import './dialogue-box.css';
import { useOutsideClickDetector } from '../../hooks/useOutsideClickDetector';

interface DialogueBoxProps {
    text: string[];
    // Callback triggered after the dialogue box closes.
    afterDialogueCb?: () => void;
}

function DialogueBox(props: DialogueBoxProps) {
    const { text, afterDialogueCb } = props;
    const [lineIndex, setLineIndex] = useState(0);
    const dialogueBoxRef = useRef(null);

    const incrementLineIndex = useCallback(() => {
        if (lineIndex < text.length) {
            setLineIndex(lineIndex + 1);
            if (lineIndex === text.length - 1) {
                afterDialogueCb?.();
            }
        }
    }, [afterDialogueCb, lineIndex, text.length]);

    // Allow players to progress through the dialogue by clicking outside the box too.
    useOutsideClickDetector(dialogueBoxRef, incrementLineIndex);

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.shiftKey || event.altKey || event.ctrlKey) {
                return;
            }
            if (event.key === 'Enter' || event.key.length === 1) {
                incrementLineIndex();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [incrementLineIndex, lineIndex, text.length]);

    return lineIndex < text.length ? (
        <div
            className="dialogue-box"
            onClick={incrementLineIndex}
            ref={dialogueBoxRef}
        >
            <div className="dialogue-text">
                {text[lineIndex].split('\n').map((line) => {
                    return (
                        <div key={line}>
                            {line}
                            <br />
                        </div>
                    );
                })}
            </div>
            {lineIndex < text.length - 1 && (
                <div className="next-line-arrow">
                    <img src={DIALOGUE_ARROW_ICON} alt="Next line indicator" />
                </div>
            )}
        </div>
    ) : (
        <></>
    );
}

export default DialogueBox;
